export default __webpack_public_path__ + "static/media/Snd3.9886e3da.mp3";